<div class="flex center" style="box-sizing: border-box; margin: 8px; overflow-x: hidden;">
  <div class="flex column align page-border" #pdfContent>
    <!-- PAGE 1 -->
    <div class="flex column align page-container">
      <div class="flex div-line" style="margin-top: 24px;">
        <strong>DATED</strong>
        <span>{{currentDate}}</span>
      </div>
      <span class="underline-text" style="margin-top: 24px;"><strong><u>GRANT LETTER</u></strong></span>
      <span class="underline-text"><strong><u>BY</u></strong></span>

      <div style="margin-top: 32px;">
        <strong>{{settlorList.toUpperCase()}}</strong>
      </div>
      <div style="margin-top: 16px;">
        <strong>{{ settlorsPrimed.length > 1 ? '"THE SETTLORS"' : '"THE SETTLOR"' }}</strong>
      </div>
      <div class="flex div-line" style="margin-top: 48px;"></div>

      <span class="underline-text" style="margin-top: 40px;"><strong><u>TO</u></strong></span>
      <span class="underline-text"><strong>ICEA LION TRUST COMPANY LIMITED</strong></span>
      <div class="underline-text">
        <strong>("THE TRUSTEE")</strong>
      </div>
      <div class="flex div-line" style="margin-top: 48px;"></div>

      <span class="underline-text" style="margin-top: 48px;">
        <strong><u>MILELE TRUST FUND REGISTERED TRUSTEES</u></strong>
      </span>
      <div class="underline-text">
        <strong>("THE TRUST")</strong>
      </div>
    </div> <!-- PAGE 1 END -->

    <!-- PAGE 2 -->
    <div class="flex column align bage-container">
      <!-- automatic overflow to next page -->
      <div class="flex column content-section">
        <div class="flex prose" style="margin-top: 32px;">
          WHEREAS the trustee has established the TRUST with the intent that it shall be held by them upon 
          the education, medical and limited upkeep trusts contained in the trust deed shown in Annex 1 to 
          this Grant Letter;
        </div>
        <!-- Bullet 1 -->
        <div class="flex">
          <div class="flex bullet">1.</div>

          <div class="flex column prose">
            <p>The Primary Settlor currently situated at <strong>{{settlorsPrimed[0] ? settlors[0].Address : '[INSERT PHYSICAL ADDRESS]' }}</strong>, 
              in {{ region === 0 ? 'the' : 'the country of residence,' }} <strong>{{ region === 0 ? 'Republic of Kenya' : capitalizeFirstLetter(settlors[0].Country) }}</strong>, with Phone Number 
              <strong>{{settlorsPrimed[0] ? settlorsPrimed[0].Phone : '[INSERT PHONE]' }}</strong> 
              and Email Address <strong>{{settlorsPrimed[0] ? settlorsPrimed[0].Email : '[INSERT EMAIL]' }}</strong>, will make available
              <strong>{{ paymentAmount }}</strong> (“the Initial Capital”), being – <strong>{{ fundSources }}</strong> 
              <strong>{{trustInfo && trustInfo.OtherSource && trustInfo.OtherSource.length > 2 ? '- '+trustInfo.OtherSource : '' }}</strong>; to 
              the Trustee to the intent that the same shall be held by or on behalf of the Trustee as an 
              accretion to the Trust Fund and from and after the date of such acceptance the Trustee shall 
              hold the Fund upon Trust to apply the same.<span *ngIf="settlorsPrimed.length > 1"> The Trust has also been assigned the below settlors:</span>
            </p>
            <div *ngIf="settlorsPrimed.length > 1" style="margin-bottom: 8px;" >
              <div *ngFor="let settlor of settlorsPrimed; let i=index">
                <p *ngIf="i > 0" style="margin-bottom: 4px;">
                  <strong>{{settlor.Title+' '+settlor.FirstName+(settlor.MiddleName && settlor.MiddleName != '' ? ' '+settlor.MiddleName+' ' : ' ')+settlor.LastName}}</strong>, 
                  whose phone number is <strong>{{settlor.Phone}}</strong> and email address is <strong>{{settlor.Email}}</strong>.
                </p>
              </div>
            </div>
            <!-- Bullet a -->
            <div class="section bordered">
              <div class="flex bullet">a.</div>

              <div class="flex column prose">
                For the general purposes of the trusts declared in the Trust Deed directed wholly 
                towards the general welfare of the following {{beneficiaryList.length > 1  ? 'beneficiaries' : 'beneficiary' }}:<br>
                <strong>
                  {{beneficiaryList.length > 0  ? beneficiaryList.join(', ') : '[INSERT NAME OF BENEFICIARY]' }}
                </strong>
              </div>
            </div>

            <p style="margin-top: 30px;">And upon any special trusts declared hereunder</p>
          </div><!-- /prose -->
        </div>
        
        <table>
          <!-- Bullet 1 CONTINUATION -->
          <!-- Bullet b -->
          <tr>
            <td></td>
            <td>
              <div class="section bordered">
                <div class="flex bullet">b.</div>
                <div class="flex prose">
                  <p>Upon trust for <i style="color: red;"> {{trustOptions }}</i> 
                  directed  wholly towards the general welfare of the following {{beneficiaryList.length > 1  ? 'beneficiaries' : 'beneficiary' }}:<br>
                  <strong>
                    {{beneficiaryList.length > 0  ? beneficiaryList.join(', ') : '[INSERT NAME OF BENEFICIARY]' }}
                  </strong>
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <!-- Bullet c -->
          <tr>
            <td></td>
            <td>
              <div class="section bordered">
                <div class="flex bullet">c.</div>
                <div class="flex prose">
                  <p>
                    Provision of all medical needs including but not limited to the purchase of adequate 
                    medical covers, life assurance policies, payment of charges and fees incurred by or on 
                    behalf of the beneficiary on account of medical consultation or hospitalisation or for 
                    prescriptions;
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <!-- Bullet d -->
          <tr>
            <td></td>
            <td>
              <div class="section bordered">
                <div class="flex bullet">d.</div>
                <div class="flex prose">
                  <p>
                    Provision of all educational needs of the beneficiary of the Trust including but not 
                    limited to payment of school, tuition and activity fees, provision of educational 
                    equipment, expenses related to apprenticeship programmes and any and all activities, 
                    events or ventures that in any manner contribute to the intellectual advancement of the 
                    beneficiary of the Trust;
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <!-- Bullet e -->
          <tr>
            <td></td>
            <td>
              <div class="section bordered">
                <div class="flex bullet">e.</div>
                <div class="flex prose">
                  <p>To provide for upkeep to the beneficiary limited to provision for food and clothing.<br>
                  <span *ngIf="arraysContainValue(beneficiaries, 'Upkeep')">Upon the Beneficiary attaining the age of 
                  <strong>{{trustInfo && trustInfo.DistributionAge ? trustInfo.DistributionAge : '[INSERT AGE OF DISTRIBUTION OF TRUST FUND]' }}</strong> 
                  years, the Trustee shall distribute to the Beneficiary an allowance of 
                  <strong>KSH {{trustInfo && trustInfo.UpkeepAmount ? formatCurrency(trustInfo.UpkeepAmount) : '[INSERT UPKEEP AMOUNT]' }}</strong>&nbsp; 
                  <strong>{{trustInfo && trustInfo.UpkeepFrequency ? trustInfo.UpkeepFrequency : '[INSERT UPKEEP FREQUENCY]' }}</strong>. 
                  Such distribution shall be made unless the Trustee, in their absolute discretion, determine 
                  otherwise in the best interests of the Beneficiary. If the Beneficiary has already received 
                  discretionary distributions before attaining the specified age, such distributions shall not 
                  affect their entitlement under this clause.</span></p>
                </div>
              </div>
            </td>
          </tr>
          <!-- Bullet f -->
          <tr>
            <td></td>
            <td>
              <div class="section bordered">
                <div class="flex bullet">f.</div>
                <div class="flex prose">
                  <p>The Trustee shall also meet from the Trust Payment of bills, expenses and charges
                    incurred on behalf of the beneficiary of the Trust which <u>it shall in its sole discretion
                    consider reasonable</u>;
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <!-- Bullet g, h -->
          <tr>
            <td></td>
            <td>
              <div class="section column bordered">
                <div class="section">
                  <div class="flex bullet">g.</div>
                  <div class="flex prose">
                    <p>The Trustee shall hold the funds in Trust for the {{beneficiaryList.length > 1  ? 'beneficiaries' : 'beneficiary' }}, 
                      <strong>{{beneficiaryList.length > 0  ? beneficiaryList.join(', ') : '[INSERT NAME OF BENEFICIARY]' }}</strong>, 
                      until such a time that the beneficiary shall attain age 
                      <strong>{{trustInfo && trustInfo.TerminationAge ? trustInfo.TerminationAge : '[INSERT AGE OF TERMINATION OF TRUST FUND]' }}</strong> 
                      or an earlier period when the <strong><u>Balance of the Funds in the Trust shall be zero</u></strong>.
                    </p>
                  </div>
                </div>
                <div class="section">
                  <div class="flex bullet">h.</div>   
                  <div class="flex prose">
                    <p>Should the Funds be available at such a time that the Beneficiary attains age <strong>
                      {{trustInfo && trustInfo.TerminationAge ? trustInfo.TerminationAge : '[INSERT AGE OF TERMINATION OF TRUST FUND]' }}</strong>, 
                      The Trustee shall prepare a summary of the accounts of the Trust and hand over the accounts and 
                      all the Funds in the Trust to the {{beneficiaryList.length > 1  ? 'beneficiaries' : 'beneficiary' }}, 
                      <strong>{{beneficiaryList.length > 0  ? beneficiaryList.join(', ') : '[INSERT NAME OF BENEFICIARY]' }}</strong>, 
                      after which the Trustee will be discharged from all liability of the Trust.<br>
                      If the Beneficiary does not survive to attain the age of 
                      <strong>{{trustInfo && trustInfo.TerminationAge ? trustInfo.TerminationAge : '[INSERT AGE OF TERMINATION OF TRUST FUND]' }}</strong> 
                      years, their share shall be distributed in accordance with the provisions set forth in this Trust Deed or as per the Trustee's 
                      discretion.
                    </p>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <!-- Bullet i -->
          <tr>
            <td></td>
            <td>
              <div class="section bordered">
                <div class="flex bullet">i.</div>

                <div class="flex prose">
                  The Trust shall terminate automatically if the Balance of the funds in the Trust shall be zero.
                </div>
              </div>
            </td>
          </tr>
          <!-- Bullet j -->
          <tr>
            <td></td>
            <td>
              <div class="section bordered">
                <div class="flex bullet">j.</div>
                <div class="flex prose">
                  <p>For ease of identification, the Trust Fund shall be referred to as 
                    <strong>{{trustInfo && trustInfo.TrustName ? trustInfo.TrustName.toUpperCase().replace('TRUSTFUND', '').replace('TRUST', '').replace('FUND', '') : '[INSERT TRUST NAME]' }} TRUST FUND</strong>
                  </p>
                </div>
              </div>
            </td>
          </tr>

          <!-- -------- -->
          <!-- Bullet 2 -->
          <tr>
            <td>2.</td>
            <td>
              <div class="section column prose" style="flex: 1; margin-top: 8px;">
                <div class="section">
                  <div class="flex bullet">(i)</div>
                  <div class="flex prose"><p>
                    In the event of any dispute or claim between the Settlor and the Trustee (“the parties”) arising 
                    out of or relating to this Grant letter, or differences arising out of or relating to this Grant 
                    Letter, the parties shall use their best efforts to settle such disputes or differences amicably, to 
                    which end they shall consult and negotiate with each other in good faith and understanding of 
                    their mutual interests, to reach a just and equitable solution to both parties;</p>
                  </div>
                </div>

                <div class="section">
                  <div class="flex bullet">(ii)</div>
                  <div class="flex prose"><p>
                    Any dispute which shall not have been settled by mutual agreement of the Parties shall be
                    finally resolved by arbitration as provided in the trust deed. The arbitral award shall be final
                    and binding on both parties.</p>
                  </div>
                </div>

                <div class="section">
                  <div class="flex bullet">(iii)</div>
                  <div class="flex prose"><p>The seat of the arbitration shall be in Nairobi.</p></div>
                </div>
              </div>
            </td>
          </tr>
          <!-- Bullet 3 -->
          <tr>
            <td>3.</td>
            <td>
              <div class="section column prose" style="margin-top: 8px;"><p>
                Notwithstanding the provisions of clause 12 of the Trust Deed, the Settlor shall at any time be at 
                liberty to remove the Trustee from the office of this Trust by giving a one month notice.
                </p>
              </div>
            </td>
          </tr>
          <!-- Bullet 4 -->
          <tr>
            <td>4.</td>
            <td>
              <div class="section column prose" style="margin-top: 8px;">
                <p style="margin-bottom: 4px;">
                  The Principal Guardian of the beneficiary is 
                  <strong>
                      {{guardians[0] ? guardians[0].FirstName + (guardians[0]?.MiddleName != '' ? ' '+guardians[0].MiddleName+' ' : ' ') +guardians[0].LastName : 'XXX' }}
                  </strong> 
                  of ID/Passport Number <strong>{{guardians[0] ? guardians[0].IDNo : 'XXX' }}</strong> 
                  and whose email address is <strong>{{guardians[0] ? guardians[0].Email : 'XXX' }}</strong> and phone number 
                  is <strong>{{guardians[0] ? guardians[0].Phone : 'XXX' }}</strong>.
                </p>
                <div *ngIf="guardianPrincipals.length > 0" >
                  <p *ngFor="let guardian of guardianPrincipals; let i=index" style="margin-bottom: 4px;">
                    <strong>
                      {{guardian.FirstName + (guardian.MiddleName && guardian.MiddleName != '' ? ' '+guardian.MiddleName+' ' : ' ') +guardian.LastName }}
                    </strong> is also a Principal Guardian of the beneficiary with ID/Passport Number <strong>{{guardian.IDNo }}</strong> 
                    and whose email address is <strong>{{guardian.Email }}</strong> and phone number is <strong>{{guardian.Phone }}</strong>
                  </p>    
                </div>
                <div *ngIf="guardiansAlternate.length > 0" >
                  <p *ngFor="let guardian of guardiansAlternate; let i=index" style="margin-bottom: 4px;">
                    <strong>
                      {{guardian.FirstName + (guardian.MiddleName && guardian.MiddleName != '' ? ' '+guardian.MiddleName+' ' : ' ') +guardian.LastName }}
                    </strong> is an alternate Guardian of the beneficiary with ID/Passport Number <strong>{{guardian.IDNo }}</strong> 
                    and whose email address is <strong>{{guardian.Email }}</strong> and phone number is <strong>{{guardian.Phone }}</strong>
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <!-- Bullet 5 -->
          <tr>
            <td>5.</td>
            <td>
              <div class="section column prose" style="margin-top: 8px;"><p>
                The fees charged by the Trustee shall be 1% per annum, charged quarterly in arrears and 
                calculated on the value of the funds held in the Trust on the date of calculation. . This fee will be 
                subject to a VAT charge. The Trustee will debit the fees and VAT to the Trust. 
                </p>
              </div>
            </td>
          </tr>
          <!-- WITNESS Text -->
          <tr>
            <td colspan="2">
              <div class="section prose" style="margin-top: 12px; flex: 1; box-sizing: border-box;">
                IN WITNESS whereof the parties confirm in writing acceptance of the terms and conditions of the 
                grant set out in this Grant Letter.
              </div>
            </td>
          </tr>
          <!-- Signatures -->
          <tr>
            <td colspan="2">
              <div class="section column prose" style="flex: 1; box-sizing: border-box;margin-top: 8px;">
                <!-- SETTLOR SIGNATURES -->
                <!-- Single Settlor -->
                <div class="flex align" *ngIf="settlorsPrimed.length < 2">
                  <div class="flex" style="margin-right: 16px;"><p>
                    Signed by 
                    <strong>
                      {{settlorsPrimed[0] ? (settlorsPrimed[0].FirstName + (settlorsPrimed[0].MiddleName && settlorsPrimed[0].MiddleName != '' ? ' '+settlorsPrimed[0].MiddleName+' '  :  ' ') + settlorsPrimed[0].LastName).toUpperCase() : 'XXX' }}
                    </strong> (The Settlor)</p>
                  </div>
                  <!-- DIGITAL SIGNATURE -->
                  <div class="flex justify under-dash">
                    <img [src]="signatureImage" class="sigholder" *ngIf="signatureImage" alt="" />
                    <div class="flex center sigholder" *ngIf="!signatureImage">
                      <div class="flex center sig-button" (click)="openSignatureModal()" (keydown.enter)="openSignatureModal()" (keydown.space)="openSignatureModal()">
                        <mat-icon>assignment_turned_in</mat-icon>
                        Please sign here
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Multiple Settlors -->
                <div *ngIf="settlorsPrimed.length > 1">
                  <p style="margin-bottom: 16px; margin-top: 0px;">Signed by (The Settlors)</p>

                  <div *ngFor="let settlor of settlorsPrimed; let i=index" class="flex align" style="margin-bottom: 50px; justify-content: space-between;" >    
                    <div class="flex column align" style="margin-right: 16px; position: relative;">
                      <div><u><strong>
                        {{(settlor.FirstName+(settlor.MiddleName && settlor.MiddleName != '' ? ' '+settlor.MiddleName+' ' : ' ')+settlor.LastName).toUpperCase() }}
                      </strong></u></div>
                      <div class="flex align" style="font-size: smaller; position: absolute; bottom: -18px; width: 100%; padding-left: 16px; box-sizing: border-box;">
                        (Name)
                      </div>
                    </div>
                    <!-- SIGNATURE -->
                    <div class="flex justify under-dash">
                      <div *ngIf="i == 0" style="margin-top: -10px;">
                        <img [src]="signatureImage" class="sigholder" *ngIf="signatureImage" alt="" />
                        <div class="flex center sigholder" *ngIf="!signatureImage">
                          <div class="flex center sig-button" (click)="openSignatureModal()" (keydown.enter)="openSignatureModal()" (keydown.space)="openSignatureModal()">
                            <mat-icon>assignment_turned_in</mat-icon>
                            Please sign here
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <!-- Trust signatures -->
          <tr>
            <td colspan="2">
              <div class="section column prose" style="flex: 1; box-sizing: border-box;">
                <div class="flex">
                  <div class="flex" style="margin-right: 16px;"><p>
                    Signed by <strong>ICEA LION TRUST COMPANY LIMITED</strong> (The Trustee)
                  </p></div>
                </div>

                <div class="flex" style="margin-top: 12px; height: 35px;">
                  <div class="flex" style="margin-right: 16px; margin-top: 20px; font-size: 14px !important;"><p>
                    Authorized signatory
                  </p></div>

                  <div class="flex center column" style="margin-right: 74px; position: relative;">
                    <div class="flex under-dash" style="margin-top: 16px; width: 300px;"><p></p></div>
                    <div class="flex center" style="font-size: smaller; position: absolute; bottom: -16px; width: 100%;">
                      (Name)
                    </div>
                  </div>
                  
                  <div class="flex under-dash"><p></p></div>
                </div>

                <div class="flex" style="margin-top: 40px; height: 40px;">
                  <div class="flex" style="margin-right: 16px; margin-top: 20px; font-size: 14px !important;"><p>
                    Authorized signatory
                  </p></div>

                  <div class="flex center column" style="margin-right: 74px; position: relative;">
                    <div class="flex under-dash" style="margin-top: 16px; width: 300px;"><p></p></div>
                    <div class="flex center" style="font-size: smaller; position: absolute; bottom: -16px; width: 100%;">
                      (Name)
                    </div>
                  </div>

                  <div class="flex under-dash"><p></p></div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div> <!-- content-section -->
    </div> <!-- PAGE 2 END -->
  </div>
</div>

<!-- Sign Grant Letter -->
<ng-template #sigContent>
  <app-signature (signatureSaved)="onSignatureSaved($event)"></app-signature>
</ng-template>